// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"240":"support","538":"recovery","585":"migration","594":"about","936":"registration","946":"news"}[chunkId] || chunkId) + "." + {"240":"925f057f","538":"b77f7851","585":"68dda691","594":"f401458e","635":"3a79c939","936":"7244fab3","946":"bc0eb50b"}[chunkId] + ".js";
};